import React from 'react';
import styled from 'styled-components';

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100% !important;
  margin-top: 40px;
  text-align: center;
  position: relative;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const SkeletonSectionTitle = styled.div`
  width: 300px;
  height: 40px;
  margin: 0 auto 20px;
  background: linear-gradient(90deg, #9cc54b 25%, #8ab03f 50%, #9cc54b 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 767px) {
    width: 200px;
    height: 32px;
  }
`;

const SkeletonBgWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  padding: 30px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  clear: both;

  @media (max-width: 768px) {
    padding: 20px;
    gap: 15px;
  }
`;

const SkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(15.5% - 20px);
  min-width: 160px;
  padding: 15px;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  @media (max-width: 1200px) {
    width: calc(19.66% - 20px);
  }

  @media (max-width: 992px) {
    width: calc(20% - 20px);
  }

  @media (max-width: 768px) {
    width: calc(25% - 15px);
    min-width: 100px;
    padding: 10px;
  }
`;

const SkeletonCardTitle = styled.div`
  width: 90%;
  height: 18px;
  margin-bottom: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 768px) {
    height: 14px;
    margin-bottom: 8px;
  }
`;

const SkeletonSquareImage = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
  border-radius: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

/**
 * CategoryListSkeleton Component
 * Title centered at top
 * Cards with title on top, square image below
 * Display in 2 rows with responsive layout
 */
const CategoryListSkeleton = ({itemCount = 10}) => {
	return (
		<SkeletonWrapper className="category-list-height">
			<SkeletonSectionTitle/>
			<SkeletonBgWrapper>
				{[...Array(itemCount)].map((_, index) => (
					<SkeletonCard key={`category-skeleton-${index}`}>
						<SkeletonCardTitle/>
						<SkeletonSquareImage/>
					</SkeletonCard>
				))}
			</SkeletonBgWrapper>
		</SkeletonWrapper>
	);
};

export default React.memo(CategoryListSkeleton);
